import EpisodeTimer from './EpisodeTimer';

export default EpisodeTimer;
